import axios from 'axios';

import { env } from '@/constant/env';
import { SpanType, withSpanAsync } from '../tracing';

export const logout = () =>
  withSpanAsync('logout', SpanType.outgoingRequest, async () =>
    axios.request({
      url: `${env.VITE_ACCOUNT_API_URL}/logout`,
      withCredentials: true
    })
  );

export const reAuthConduent = password =>
  withSpanAsync('reAuthConduent', SpanType.outgoingRequest, async () =>
    axios.request({
      url: `${env.VITE_ACCOUNT_API_URL}/reauth/conduent`,
      method: 'POST',
      data: { password },
      withCredentials: true
    })
  );
